// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OH0Om","toggle":"styles_toggle__2YhHV","preview":"styles_preview__bDxIp"};